'use client';
import { createClientContext } from '../utils/ContextUtils.js';
export const NotificationContext = createClientContext(undefined);
//# sourceMappingURL=NotificationContext.js.map